"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountStatus = void 0;
var AccountStatus;
(function (AccountStatus) {
    AccountStatus["New"] = "New";
    AccountStatus["Accepted"] = "Accepted";
    AccountStatus["Disabled"] = "Disabled";
})(AccountStatus = exports.AccountStatus || (exports.AccountStatus = {}));
//# sourceMappingURL=account-status.js.map